import { SubmitButton } from 'components/Form/SubmitButton/SubmitButton';

import {
  EditSavedSearchFormCheckboxField,
  EditSavedSearchFormInputField,
} from './EditSavedSearchForm.styled';

export function EditSavedSearchForm() {
  return (
    <>
      <EditSavedSearchFormInputField
        label={getText('Name your search')}
        name="name"
      />
      <EditSavedSearchFormCheckboxField
        label={getText('Email Alerts for this search')}
        name="notifyByEmail"
        toggle
      />
      <SubmitButton fullWidth>{getText('Update')}</SubmitButton>
    </>
  );
}
